import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function getShippingReqFormsList(config) {
  try {
    return await DBOperations.fetchData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField, // for sorting fields ex: sortField: ["group_order", "mandatory", "item_order"],
      config.sortOrder, // for sort order     ex: sortOrder: [1, -1, 1],
      config.page,
      config.rows,
      config.fetchAll,
      config.queryParams
    );
  } catch (error) {
    Exception.catchException(error);
    return {
      error
    };
  }
}

async function getShippingReqFormById(id) {
  try {
    const _res = await DBOperations.getData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      id
    );
    if (_res.error) throw _res.error;
    return _res;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function createShippingReq(data) {
  try {
    return await DBOperations.insertData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      data
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function updateShippingReq(data) {
  try {
    return await DBOperations.updateData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      data
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

export default {
  getShippingReqFormsList,
  getShippingReqFormById,
  createShippingReq,
  updateShippingReq
};
